import type { Schema } from '@wix/wix-data-schema-types'
import type { IndexedFields, IndexedFieldSpec, IndexedSchema } from './types'

interface GroupedFields {
  fieldsWithIndices: string[]
  fieldsWithoutIndices: string[]
}

const _assignFieldIndices = (fields: {
  [fieldName: string]: IndexedFieldSpec
}) => {
  const bitset: number[] = []
  const fieldKeys = Object.keys(fields)

  const { fieldsWithIndices, fieldsWithoutIndices } = fieldKeys.reduce(
    (f: GroupedFields, fieldKey) => {
      if (typeof fields[fieldKey].index === 'number') {
        bitset[fields[fieldKey].index] = 1
        f.fieldsWithIndices.push(fieldKey)
      } else {
        f.fieldsWithoutIndices.push(fieldKey)
      }
      return f
    },
    {
      fieldsWithoutIndices: [],
      fieldsWithIndices: [],
    },
  )

  const indicesAreNotSparse =
    bitset.length === fieldKeys.length &&
    bitset.join('').length === fieldKeys.length

  if (indicesAreNotSparse) {
    return fields
  }

  const newFields = { ...fields }
  fieldsWithIndices
    .sort((a, b) => fields[a].index - fields[b].index)
    .forEach(
      (fieldKey, i) =>
        (newFields[fieldKey] = { ...newFields[fieldKey], index: i }),
    )
  fieldsWithoutIndices.forEach(
    (fieldKey, i) =>
      (newFields[fieldKey] = {
        ...newFields[fieldKey],
        index: fieldsWithIndices.length + i,
      }),
  )

  return newFields
}

const addFieldIndicesIfNeeded = (schema: Schema): IndexedSchema => ({
  ...schema,
  fields: _assignFieldIndices(schema.fields as IndexedFields),
})

export default addFieldIndicesIfNeeded
